import { createContext, useState } from "react";

export const PrayerIdContext = createContext({
  prayerId: null,
  setPrayerId: () => null,
});

export const PrayerIdProvider = ({ children }) => {
  const [prayerId, setPrayerId] = useState(null);
  const value = { prayerId, setPrayerId };
  return (
    <PrayerIdContext.Provider value={value}>
      {children}
    </PrayerIdContext.Provider>
  );
};
